import React from 'react';
import { string, shape } from 'prop-types';
import GoogleIcon from 'components/google-icon';

export default function FacultyListing({ item }) {
    return (
        <div className="c-faculty-listing">
            <div className="faculty-listing-wrapper">
                <div className="faculty-photo-profile">
                    <div className="ratio-wrapper">
                        <img src={item.thumbnail} alt={item.title} />
                    </div>
                </div>
                <div className="faculty-details">
                    <div className="faculty-list-details">
                        <h3><a href={item.url}>{item.title}</a></h3>
                        <p>{item.position}</p>
                        <div className="faculty-detail-item">
                            <div className="detail-item">
                                <div className="detail-item-label"><GoogleIcon icon="school" /> Qualifications:</div>
                                <span className="detail-item-description">{item.qualification}</span>
                            </div>
                            <div className="detail-item">
                                <div className="detail-item-label"><GoogleIcon icon="verified" /> Specialisation:</div>
                                <span className="detail-item-description">{item.specialisation}</span>
                            </div>
                            <div className="detail-item">
                                <div className="detail-item-label"><GoogleIcon icon="chat" /> Topics:</div>
                                <span className="detail-item-description">{item.topics}</span>
                            </div>
                        </div>
                    </div>
                    <div className="faculty-links">
                        <div className="faculty-links-contact">
                            {item.email &&
                                <div className="faculty-email">
                                    <GoogleIcon icon="email" />
                                    <a href={`mailto:${item.email}`} target="_blank">{item.email}</a>
                                </div>
                            }
                            {item.phone &&
                                <div className="faculty-phone">
                                    <GoogleIcon icon="phone" />
                                    <a href={`tel:${item.phone}`} target="_blank">{item.phone}</a>
                                </div>
                            }
                        </div>
                        <a href={item.url} title={item.title} className="btn-skin-1 btn-small">View Profile</a>
                    </div>
                </div>
            </div>
        </div>
    );
}

FacultyListing.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    item: shape({
        url: string.isRequired,
        title: string.isRequired,
        position: string,
        qualification: string,
        specialisation: string,
        topics: string,
        thumbnail: string,
        email: string,
        phone: string
    }).isRequired
    /* eslint-enable react/no-typos */
};
